import React, { useState } from 'react';
import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { shouldUseDummyButton } from '../../../../util';
import { FullColoredTicketButton } from '../../../common/buttonsComponents';
import { ToolTip } from '../../../common/tooltips';
import { CopyButtonWrapper, DecisionFlowDummyButton } from './DummyButton.styles';
import { useDummyButton } from './useDummyButton';

const DummyButton = (props) => {
  const [showCopySuccess, setShowCopySuccess] = useState(false);
  const { decisionFlow = false, selectedInboxTab, disabled, buttonData, onClick } = props;

  const dummyButtonData = isString(buttonData) ? { label: buttonData, tags: [buttonData] } : buttonData;

  if (isEmpty(dummyButtonData?.tags) || !buttonData) {
    return null;
  }

  const labelSplit = dummyButtonData.label.split('simplr_');
  const hoverText = labelSplit.length > 1 ? labelSplit[1] : labelSplit[0];
  const buttonText = hoverText.toUpperCase();

  const handleButtonClick = () => {
    setShowCopySuccess(true);
    onClick();
    setTimeout(() => {
      setShowCopySuccess(false);
    }, 3000);
  };

  const ButtonComponent = decisionFlow ? DecisionFlowDummyButton : FullColoredTicketButton;

  return (
    <div style={{ marginLeft: '20px' }}>
      <CopyButtonWrapper>
        <ToolTip arrow placement="top" content={showCopySuccess ? 'Action Executed!' : hoverText}>
          <ButtonComponent
            disabled={!shouldUseDummyButton(selectedInboxTab) || disabled}
            active={shouldUseDummyButton(selectedInboxTab) || !disabled}
            onClick={handleButtonClick}
          >
            {showCopySuccess ? 'Action Executed!' : buttonText}
          </ButtonComponent>
        </ToolTip>
      </CopyButtonWrapper>
    </div>
  );
};

DummyButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedInboxTab: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

DummyButton.useDummyButton = useDummyButton;

export default DummyButton;
